export default __webpack_public_path__ + "static/media/pexels-babix-33345009.2eaf77c9.jpg";